module.exports = __webpack_public_path__ + "fonts/montserrat-blackitalic-webfont.cb81c90.woff2";